import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { GananciasOcasionalesAccionesModalComponent } from '../modales/ganancias-ocasionales/ganancias-ocasionales-acciones-modal/ganancias-ocasionales-acciones-modal.component';
import { GananciasOcasionalesIndemnizacionModalComponent } from '../modales/ganancias-ocasionales/ganancias-ocasionales-indemnizacion-modal/ganancias-ocasionales-indemnizacion-modal.component';

import { ImpuestoRentaSaldoaFavorDeclaracionAñoAnteriorModalComponent } from '../modales/impuesto-renta/impto-renta-saldo-a-favor-ano-anterior-modal/impto-renta-saldo-a-favor-ano-anterior-modal.component';
import { ImpuestoRentaTuvoCostosyGastosaDeducirModalComponent } from '../modales/impuesto-renta/impto-renta-costos-y-gastos-para-deducir-modal/impto-renta-costos-y-gastos-para-deducir-modal.component';


import { DDocumento } from '@dian/api-formulario';
import { HandlerComponent, Question } from '../handler-component';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { MessageObservableService } from '../../../../services/message-observable.service';
import { DialogoConfirmacionComponent } from '../../../table-items/dialogo-confirmacion/dialogo-confirmacion.component';
import { CompensacionModalComponent } from '../modales/impuesto-renta/compensacion-modal/compensacion-modal.component';
import { DValorDominio } from '@dian/api-basicos-parametricas';
import { RentasLiquidasGravablesComponent } from '../modales/impuesto-renta/rentas-liquidas-gravables-modal/rentas-liquidas-gravables-modal.component';
import { AnticiposComponent } from '../modales/impuesto-renta/anticipos-modal/anticipos-modal.component';
import { SancionComponent } from '../modales/impuesto-renta/sancion-modal/sancion-modal.component';

const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo

const questions: Question[] = [
  {
    question: '¿Tuvo costos y gastos para deducir?',
    field: 'cs_id_744', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_748"
  },
  {
    question: '¿Tuvo pérdidas o exceso de renta presuntiva, que quiera compensar?',
    field: 'cs_id_782', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_792"
  },
  {
    question: '¿Tuvo rentas por omisión de activos, pasivos inexistentes o recuperación de deducciones?',
    field: 'cs_id_768', show: false, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_781"
  },
  {
    question: 'Consulte si debe pagar anticipo de renta',
    field: 'cs_id_800', show: true, nextIfValue: "0", isCompleted: false, resp: "1", hasSuggested: "0", totalField: "cs_id_797"
  },
  {
    question: '¿Tuvo saldo a favor en la declaración de renta del año anterior?',
    field: 'cs_id_808', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_810"
  },
  {
    question: '¿Su declaración de renta está fuera de la fecha de vencimiento?',
    field: 'cs_id_811', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_819"
  },

];


// 744 R1  ¿Tuvo costos y gastos para deducir ?
// 782 R2  ¿Tuvo pérdidas o exceso de renta presuntiva, que quiera compensar?
// 768 R3  ¿Tuvo rentas por omisión de activos, pasivos inexistentes o recuperación de deducciones?
// 800 R4  ¿Tiene que pagar anticipo de renta para el año siguiente? 
// 808 R5  ¿Tuvo saldo a favor en la declaración de renta del año anterior?
// 811 R6  ¿Su declaración de renta está fuera de la fecha de vencimiento?

@Component({
  selector: 'app-mi-impuesto-de-renta',
  templateUrl: './mi-impuesto-de-renta.component.html',
  styleUrls: ['./mi-impuesto-de-renta.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class MiImpuestoDeRentaComponent extends HandlerComponent implements OnInit {

  @Input('model') model: DDocumento = new DDocumento();
  @Input('model210') model210: DDocumento = new DDocumento();
  @Input('tablaArt73') tablaArt73: any;
  @Input('listTipoCompensacion') listTipoCompensacion: DValorDominio[] = [];
  @Input('listTipoRenta') listTipoRenta: DValorDominio[] = [];
  @Input('listTipoRentaLiquidaGravable') listTipoRentaLiquidaGravable: DValorDominio[] = [];
  @Input('listaAniosDeclarados') listaAniosDeclarados: DValorDominio[] = [];
  @Input('listaAniosExtemporaneidad') listaAniosExtemporaneidad: DValorDominio[] = [];
  @Input('valUVT') valUVT: string = "0";

  @Input('listaTipRentaAFC') listaTipoRentaCostosGastosDeducibles: any;
  @Output('isCompleted') isCompleted: EventEmitter<boolean> = new EventEmitter<false>();
  @Output('saveModel') saveModel: EventEmitter<boolean> = new EventEmitter<false>();
  @Output('activarGuardado') activarGuardado:EventEmitter<boolean> = new EventEmitter<false>();

  constructor(
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    private dialog: MatDialog,
    private _messagesObs: MessageObservableService

  ) {
    super(questions);
  }

  ngOnInit() {
    this.initilizeQuestionsDesdeModelo(this.model);
    this.initializeSiTieneSugerida();
  }

  validateQuestions(id: number) {
    console.log(id);

  }

  private listenMessagesObs() {
    this._messagesObs.getMessages().subscribe(res => {

    });
  }

  questionHasSugerida(index: number) {
    return questions[index].hasSuggested == "1";
  }
  /**
   * Inicializa las respuestas en Sí si la sección tiene sugerida
   */
  initializeSiTieneSugerida() {
    for (let numPregunta = 0; numPregunta < questions.length; numPregunta++) {
      if (this.questionHasSugerida(numPregunta) && questions[numPregunta].resp != "0") {
        questions[numPregunta].resp = '1';
        this.model.doc.cuerpo[questions[numPregunta].field] = "1";
      }
    }
  }

  initilizeQuestionsDesdeModelo(model) {
    for (let i = 0; i < questions.length; i++) {
      if(i==3){//Regla, en pregunta de anticipios dejar por defecto respondido SI
        questions[i].resp = "1";
      }else{
        questions[i].resp = model.doc.cuerpo[questions[i].field];
      }
      questions[i].isCompleted = this.validateModalCompleted(i);
      if (questions[i].isCompleted || model.doc.cuerpo[questions[i].field] == "1") { questions[i].show = true; }
      this.checkNextQuestion(i);
    }
  }

  openModal(indexQuestionModal: number) {
    const configSinSugerida = {
      minHeight: '80vh',
      minWidth: '80%',
      disableClose: true,
      data: this.model
    };
    const configSugerida = {
      minHeight: '80vh',
      minWidth: '80%',
      disableClose: true,
      data: {
        model: this.model
      }
    }
    let config;
    if (this.questionHasSugerida(indexQuestionModal)) {
      config = configSugerida;
    } else {
      config = configSinSugerida;
    }

    switch (indexQuestionModal) {
      case 0:  //744 R1  ¿Tuvo costos y gastos para deducir ?
        const dialog0 = this.dialog.open(ImpuestoRentaTuvoCostosyGastosaDeducirModalComponent, config);
        dialog0.componentInstance.listaTipoRentaCostosGastosDeducibles = this.listaTipoRentaCostosGastosDeducibles;
        //dialog0.componentInstance.tablaArt73 = this.tablaArt73;
        dialog0.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog0.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;

      case 1:  //782 R2  ¿Tuvo pérdidas o exceso de renta presuntiva, que quiera compensar?
        const dialog1 = this.dialog.open(CompensacionModalComponent, config);
        dialog1.componentInstance.listTipoCompensacion = this.listTipoCompensacion;
        dialog1.componentInstance.listTipoRenta = this.listTipoRenta;
        dialog1.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog1.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
          console.log(data);
        });
        break;
      case 2:  //768 R3  ¿Tuvo rentas por omisión de activos, pasivos inexistentes o recuperación de deducciones?
        const dialog2 = this.dialog.open(RentasLiquidasGravablesComponent, config);
        dialog2.componentInstance.listTipoRentaLiquidaGravable = this.listTipoRentaLiquidaGravable;
        dialog2.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog2.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 3:  //800 R4  ¿Ha declarado renta en años anteriores?
        const dialog3 = this.dialog.open(AnticiposComponent, config);
        dialog3.componentInstance.listaAniosDeclarados = this.listaAniosDeclarados;
        dialog3.componentInstance.model210 = this.model210;
        dialog3.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
          this.activarGuardado.emit(true);
        });
        dialog3.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 4:  //808 R5  ¿Tuvo saldo a favor en la declaración de renta del año anterior?
        const dialog4 = this.dialog.open(ImpuestoRentaSaldoaFavorDeclaracionAñoAnteriorModalComponent, config);
        dialog4.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog4.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 5:  //811 R6  ¿Su declaración de renta está fuera de la fecha de vencimiento?
        const dialog5 = this.dialog.open(SancionComponent, config);
        dialog5.componentInstance.valUVT = this.valUVT;
        dialog5.componentInstance.listaAniosExtemporaneidad = this.listaAniosExtemporaneidad;
        dialog5.componentInstance.model210 = this.model210;
        dialog5.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog5.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      default:
        break;
    }
  }

  protected validateModalCompleted(indexQuestion: number): boolean {
    let isModalComplete: boolean = false;
    let valCasTotal = this.model.doc.cuerpo[questions[indexQuestion].totalField] ? this.model.doc.cuerpo[questions[indexQuestion].totalField].toString() : "0";
    if ((this.model.doc.cuerpo[questions[indexQuestion].field] != undefined && this.model.doc.cuerpo[questions[indexQuestion].field] == "0") ||
      this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valCasTotal, "0")) {
      isModalComplete = true;
    }
    if(indexQuestion==3){//Regla con anticipos, no valida con totalField=0 sino si tiene algún registro en la tabla
      if(this.model.doc.cuerpo.cc_id_802 != undefined && this.model.doc.cuerpo.cc_id_802.length>0){
        isModalComplete = true;
      }
    }
    if (isModalComplete) {
      questions[indexQuestion].isCompleted = true;
      if (questions.length > indexQuestion + 1) questions[indexQuestion + 1].show = true;//Habilitar visibilidad de la siguiente pregunta
    } else {
      questions[indexQuestion].isCompleted = false;
      //if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = false;
    }
    this.validateComponentCompleted();
    return isModalComplete;
  }

  public validateComponentCompleted(): boolean {
    for (let i = 0; i < questions.length; i++) {
      if (questions[i].isCompleted == false) {
        this.isCompleted.emit(false);
        return false;
      }
    }
    this.isCompleted.emit(true);//Componente completo!
    return true;
  }


  protected validateHasModalValues(indexQuestion: number): boolean {
    let hasValues: boolean = false;
    let valCasTotal = this.model.doc.cuerpo[questions[indexQuestion].totalField] ? this.model.doc.cuerpo[questions[indexQuestion].totalField].toString() : "0";
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valCasTotal, "0")) {
      hasValues = true;
    }
    return hasValues;
  }

  protected cleanModalValues(indexQuestionModal: number) {
    switch (indexQuestionModal) {
      case 0:  //744 R1  ¿Tuvo costos y gastos para deducir 
        this.model.doc.cuerpo.cc_id_746 = [];
        this.model.doc.cuerpo.cc_id_747 = [];
        this.model.doc.cuerpo.cs_id_748 = "0";

        this.model.doc.cuerpo.cc_id_745 = [];


        break;
      case 1:  //782 R2  ¿Tuvo pérdidas o exceso de renta presuntiva, que quiera compensar?
        this.model.doc.cuerpo.cc_id_789 = [];
        this.model.doc.cuerpo.cc_id_790 = [];
        this.model.doc.cuerpo.cc_id_791 = [];
        this.model.doc.cuerpo.cc_id_792 = "0";

        // this.model.doc.cuerpo.cs_id_765 = "0";
        // this.model.doc.cuerpo.cs_id_766 = "0";
        // this.model.doc.cuerpo.cs_id_792 = "0";
        // this.model.doc.cuerpo.cc_id_711 = [];
        // this.model.doc.cuerpo.cc_id_187 = [];
        // this.model.doc.cuerpo.cc_id_178 = [];
        // this.model.doc.cuerpo.cc_id_179 = [];
        // this.model.doc.cuerpo.cc_id_180 = [];
        // this.model.doc.cuerpo.cc_id_186 = [];
        // this.model.doc.cuerpo.cc_id_181 = [];
        // this.model.doc.cuerpo.cc_id_182 = [];
        // this.model.doc.cuerpo.cc_id_714 = [];
        // this.model.doc.cuerpo.cc_id_188 = [];
        // this.model.doc.cuerpo.cc_id_183 = [];
        // this.model.doc.cuerpo.cc_id_185 = [];
        // this.model.doc.cuerpo.cc_id_184 = [];
        // this.model.doc.cuerpo.cc_id_193 = [];
        // this.model.doc.cuerpo.cc_id_712 = [];
        // this.model.doc.cuerpo.cs_id_699 = "0";//Indicador de Completo
        break;
      case 2:  //768 R3  ¿Tuvo rentas por omisión de activos, pasivos inexistentes o recuperación de deducciones?

        this.model.doc.cuerpo.cc_id_779 = [];
        this.model.doc.cuerpo.cc_id_780 = [];
        this.model.doc.cuerpo.cc_id_783 = [];
        this.model.doc.cuerpo.cs_id_781 = "0";
        this.model.doc.cuerpo.cc_id_789 = [];
        this.model.doc.cuerpo.cc_id_790 = [];
        this.model.doc.cuerpo.cc_id_791 = [];
        this.model.doc.cuerpo.cs_id_792 = "0";

        break;
      case 3:  //800 R4  ¿Ha declarado renta en años anteriores?

        this.model.doc.cuerpo.cs_id_802 = "0";  //802	Años declarados
        this.model.doc.cuerpo.cs_id_795 = "0";  //795	Anticipo de renta pagado año anterior
        this.model.doc.cuerpo.cs_id_796 = "0";  //796	Impuesto neto de renta año anterior
        this.model.doc.cuerpo.cs_id_806 = "0";  //806	Valor anticipo a declarar
        this.model.doc.cuerpo.cs_id_797 = "0";  //797	Retenciónes
        this.model.doc.cuerpo.cc_id_797 = [];  //797	Retenciónes
        this.model.doc.cuerpo.cs_id_801 = "0";  //801	Promedio impuesto neto de renta
        this.model.doc.cuerpo.cc_id_801 = [];  //801	Promedio impuesto neto de renta
        this.model.doc.cuerpo.cs_id_803 = "0";  //803	Porcentaje
        this.model.doc.cuerpo.cc_id_803 = [];  //803	Porcentaje
        this.model.doc.cuerpo.cs_id_804 = "0";  //804	Anticipo de renta Impuesto Neto promedio
        this.model.doc.cuerpo.cs_id_805 = "0";  //805	Anticipo de renta Impuesto Neto actual
        this.model.doc.cuerpo.cc_id_804 = [];  //804	Anticipo de renta Impuesto Neto promedio
        this.model.doc.cuerpo.cc_id_805 = [];  //805	Anticipo de renta Impuesto Neto actual

        break;
      case 4:  //808 R5  ¿Tuvo saldo a favor en la declaración de renta del año anterior?
        this.model.doc.cuerpo.cs_id_810 = "0";//Indicador de Completo
        break;
      case 5:  //811 R6  ¿Su declaración de renta está fuera de la fecha de vencimiento?
        this.model.doc.cuerpo.cs_id_819 = "0";//Numérica  Valor de la sanción
        this.model.doc.cuerpo.cs_id_812 = "0";//Numérica  Patrimonio año anterior
        this.model.doc.cuerpo.cs_id_817 = "";//Dominio  Ultimas declaraciones presentadas extemporáneamente
        this.model.doc.cuerpo.cs_id_818 = "";//Fecha  Fecha en la que presentará la declaración
        this.model.doc.cuerpo.cs_id_822 = "";//Fecha  Fecha de vencimiento
        this.model.doc.cuerpo.cc_id_822 = [];//Fecha  Fecha de vencimiento
        this.model.doc.cuerpo.cs_id_823 = "0";//Numérica//Indicador de Completo  Extemporaneidad
        this.model.doc.cuerpo.cc_id_823 = [];//Numérica//Indicador de Completo  Extemporaneidad
        break;
    }
    this.dependenciaTarjetas(indexQuestionModal);
    this.saveModel.emit(true);

  }

  changeValue(data: any, index: number) {
    questions[index].resp = data.value.toString();
    this.model.doc.cuerpo[data.field] = data.value.toString();
    if (this.model.doc.cuerpo[data.field] == "0") {
      if (this.questionHasSugerida(index)) {
        const dialogRef = this.dialog.open(DialogoConfirmacionComponent, {
          data: {
            mensaje1: 'Usted tiene información sugerida para esta pregunta',
            mensaje2: 'Puede revisarla u omitirla para continuar con la siguiente pregunta.',
            botonTrue: 'Revisar',
            botonFalse: 'Omitir'
          }
        });
        dialogRef
          .afterClosed().subscribe(res => {

            if (res) {
              this.model.doc.cuerpo[data.field] = "1";//restaura el radio button a Sí
              this.validateModalCompleted(index);
              this.saveModel.emit(true);
              this.openModal(index);
              questions[index].resp = "1";
              return;//sale sin mostrar el segundo modal que pregunta si quiere eliminar los datos
            } else {
              this.validateModalCompleted(index);
            }
            this.askIfDeleteModalData(index, data);

          });

      } else {
        this.validateModalCompleted(index);
        this.askIfDeleteModalData(index, data);
      }

    } else if (this.model.doc.cuerpo[data.field] == "1") {
      questions[index].isCompleted = false;
      this.validateModalCompleted(index);//Valida antes de abrir el modal por si ya lo había completado para que siga mostrándolo completo
      this.openModal(index);
      this.saveModel.emit(true);
    }
    this.checkNextQuestion(index);
    this.validateComponentCompleted();
  }


  private askIfDeleteModalData(index: number, data: any) {
    if (this.validateHasModalValues(index)) {

      const dialogRef2 = this.dialog.open(DialogoConfirmacionComponent, {
        data: {
          mensaje1: '¿Está seguro de eliminar esta información?',
          mensaje2: 'Al hacerlo no podrá recuperarla.',
          botonTrue: 'Sí',
          botonFalse: 'No'
        }
      });
      dialogRef2
        .afterClosed().subscribe(result => {
          if (result) { //si desea eliminar el contenido del modal
            questions[index].isCompleted = true;
            this.cleanModalValues(index);
            this.validateModalCompleted(index);
            this.saveModel.emit(true);
          } else { //no desea eliminar el contenido del modal
            questions[index].resp = "1";
            this.model.doc.cuerpo[data.field] = "1";
            this.validateModalCompleted(index);
            this.saveModel.emit(true);
          }
        });
    } else {
      questions[index].isCompleted = true;
      this.cleanModalValues(index);
      this.validateModalCompleted(index);
      this.saveModel.emit(true);
    }
  }
  dependenciaTarjetas(indexQuestionModal:number)
  {
    switch (indexQuestionModal) {
      case 0:  //744 R1  ¿Tuvo costos y gastos para deducir ?
        break;

      case 1:  //782 R2  ¿Tuvo pérdidas o exceso de renta presuntiva, que quiera compensar?
        break;
      case 2:  //768 R3  ¿Tuvo rentas por omisión de activos, pasivos inexistentes o recuperación de deducciones?
        break;
      case 3:  //800 R4  ¿Ha declarado renta en años anteriores?
        break;
      case 4:  //808 R5  ¿Tuvo saldo a favor en la declaración de renta del año anterior?
        break;
      case 5:  //811 R6  ¿Su declaración de renta está fuera de la fecha de vencimiento?
        break;
      default:
        break;
    }
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/mi-impuesto-de-renta/mi-impuesto-de-renta.component.ts